import styled from "styled-components";
import { css } from "@stubhub/broadway-foundation/css";

export const Layout = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(4)};
  @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
    gap: ${({ theme }) => theme.spacing(8)};
  }
`;

export const RowLayout = styled(Layout)`
  flex-direction: row;
`;

export const Container = styled(Layout)`
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const filterContainer = css({
  display: "flex",
  columnGap: "primitives.100",
  rowGap: "primitives.100",
  paddingInlineEnd: "primitives.25",
  paddingBlock: "primitives.25",
  "& > div": {
    display: "inline-flex",
  },
});
